import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  slot: "panel-menu",
  type: "panel",
  class: "d-block",
  "aria-label": "Mobile navigation"
}
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = {
  name: "Metrics",
  "aria-label": "Desktop Navigation"
}
const _hoisted_4 = { class: "nav-title__icon" }
const _hoisted_5 = { class: "nav-title__icon" }
const _hoisted_6 = { class: "nav-title__icon" }
const _hoisted_7 = { class: "nav-title__icon" }
const _hoisted_8 = { class: "nav-title__icon" }
const _hoisted_9 = {
  id: "mainContent",
  class: "w-100 fill-content"
}
const _hoisted_10 = { class: "container-fluid h-xxl-100" }
const _hoisted_11 = { class: "row h-xxl-100" }
const _hoisted_12 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_som_list_item = _resolveComponent("som-list-item")!
  const _component_som_list_parent_item = _resolveComponent("som-list-parent-item")!
  const _component_som_list = _resolveComponent("som-list")!
  const _component_som_header = _resolveComponent("som-header")!
  const _component_som_icon_subtract_alt = _resolveComponent("som-icon-subtract-alt")!
  const _component_som_icon_add_filled = _resolveComponent("som-icon-add-filled")!
  const _component_som_collapse = _resolveComponent("som-collapse")!
  const _component_som_sidebar = _resolveComponent("som-sidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_som_footer = _resolveComponent("som-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_som_header, {
      "app-name": "MiEconomy",
      "department-name": "Department of Technology, Management, and Budget",
      "main-content-id": "mainContent",
      "home-link": _ctx.baseURL,
      breakpoint: "lg",
      ref: "header"
    }, {
      default: _withCtx(() => [
        _createElementVNode("nav", _hoisted_1, [
          _createVNode(_component_som_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_som_list_item, {
                active: _ctx.$router.currentRoute.value.name === 'Home'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: "/",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$refs.header.closePanelMenu()))
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("Dashboard ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["active"]),
              _createVNode(_component_som_list_parent_item, { "display-name": "Labor Force" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.laborForce, (source) => {
                    return (_openBlock(), _createBlock(_component_som_list_item, {
                      key: source.topic,
                      active: source.topic === _ctx.$router.currentRoute.value.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: `/laborForce/${source.topic}`,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$refs.header.closePanelMenu()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(source.metric), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1032, ["active"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_som_list_parent_item, { "display-name": "Unemployment" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unemployment, (source) => {
                    return (_openBlock(), _createBlock(_component_som_list_item, {
                      key: source.topic,
                      active: source.topic === _ctx.$router.currentRoute.value.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: `/unemployment/${source.topic}`,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$refs.header.closePanelMenu()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(source.metric), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1032, ["active"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_som_list_parent_item, { "display-name": "Industry Jobs" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industryJobs, (source) => {
                    return (_openBlock(), _createBlock(_component_som_list_item, {
                      key: source.topic,
                      active: source.topic === _ctx.$router.currentRoute.value.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: `/industryJobs/${source.topic}`,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (this.$refs.header.closePanelMenu()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(source.metric), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1032, ["active"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_som_list_parent_item, { "display-name": "Economy" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.economy, (source) => {
                    return (_openBlock(), _createBlock(_component_som_list_item, {
                      key: source.topic,
                      active: source.topic === _ctx.$router.currentRoute.value.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: `/economy/${source.topic}`,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (this.$refs.header.closePanelMenu()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(source.metric), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1032, ["active"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_som_list_parent_item, { "display-name": "Population" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.population, (source) => {
                    return (_openBlock(), _createBlock(_component_som_list_item, {
                      key: source.topic,
                      active: source.topic === _ctx.$router.currentRoute.value.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: `/population/${source.topic}`,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (this.$refs.header.closePanelMenu()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(source.metric), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1032, ["active"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["home-link"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_som_sidebar, null, {
        default: _withCtx(() => [
          _createElementVNode("nav", _hoisted_3, [
            _createVNode(_component_som_list, { type: "sidebar" }, {
              default: _withCtx(() => [
                _createVNode(_component_som_list_item, {
                  active: _ctx.$router.currentRoute.value.name === 'Home'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (this.$refs.header.closePanelMenu())),
                      class: "nav-title__label"
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("Dashboard ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["active"])
              ]),
              _: 1
            }),
            _createElementVNode("button", {
              type: "button",
              class: "d-flex justify-content-between nav-title",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggle(this.$refs.laborForceMenu)))
            }, [
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "nav-title__label" }, "Labor Force", -1)),
              _createElementVNode("span", _hoisted_4, [
                (_ctx.accordStats.laborForceMenu)
                  ? (_openBlock(), _createBlock(_component_som_icon_subtract_alt, {
                      key: 0,
                      display: "block"
                    }))
                  : (_openBlock(), _createBlock(_component_som_icon_add_filled, {
                      key: 1,
                      display: "block"
                    }))
              ])
            ]),
            _createVNode(_component_som_collapse, {
              "aria-expanded": "false",
              ref: "laborForceMenu",
              onCollapseToggled: _cache[8] || (_cache[8] = ($event: any) => (_ctx.alert('hi'))),
              collapsed: "true"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_som_list, {
                  class: "mb-2",
                  type: "sidebar"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.laborForce, (source) => {
                      return (_openBlock(), _createBlock(_component_som_list_item, {
                        key: source.topic,
                        active: source.topic === _ctx.$router.currentRoute.value.name
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: `/laborForce/${source.topic}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(source.metric), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1032, ["active"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512),
            _createElementVNode("button", {
              type: "button",
              class: "d-flex justify-content-between nav-title",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggle(this.$refs.unemploymentMenu)))
            }, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "nav-title__label" }, "Unemployment", -1)),
              _createElementVNode("span", _hoisted_5, [
                (_ctx.accordStats.unemploymentMenu)
                  ? (_openBlock(), _createBlock(_component_som_icon_subtract_alt, {
                      key: 0,
                      display: "block"
                    }))
                  : (_openBlock(), _createBlock(_component_som_icon_add_filled, {
                      key: 1,
                      display: "block"
                    }))
              ])
            ]),
            _createVNode(_component_som_collapse, {
              "aria-expanded": "false",
              ref: "unemploymentMenu",
              collapsed: "true"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_som_list, {
                  class: "mb-2",
                  type: "sidebar"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unemployment, (source) => {
                      return (_openBlock(), _createBlock(_component_som_list_item, {
                        key: source.topic,
                        active: source.topic === _ctx.$router.currentRoute.value.name
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: `/unemployment/${source.topic}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(source.metric), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1032, ["active"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512),
            _createElementVNode("button", {
              type: "button",
              class: "d-flex justify-content-between nav-title",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggle(this.$refs.industryJobsMenu)))
            }, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "nav-title__label" }, "Industry Jobs", -1)),
              _createElementVNode("span", _hoisted_6, [
                (_ctx.accordStats.industryJobsMenu)
                  ? (_openBlock(), _createBlock(_component_som_icon_subtract_alt, {
                      key: 0,
                      display: "block"
                    }))
                  : (_openBlock(), _createBlock(_component_som_icon_add_filled, {
                      key: 1,
                      display: "block"
                    }))
              ])
            ]),
            _createVNode(_component_som_collapse, {
              "aria-expanded": "false",
              ref: "industryJobsMenu",
              collapsed: "true"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_som_list, {
                  class: "mb-2",
                  type: "sidebar"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industryJobs, (source) => {
                      return (_openBlock(), _createBlock(_component_som_list_item, {
                        key: source.topic,
                        active: source.topic === _ctx.$router.currentRoute.value.name
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: `/industryJobs/${source.topic}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(source.metric), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1032, ["active"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512),
            _createElementVNode("button", {
              type: "button",
              class: "d-flex justify-content-between nav-title",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggle(this.$refs.economyMenu)))
            }, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "nav-title__label" }, "Economy", -1)),
              _createElementVNode("span", _hoisted_7, [
                (_ctx.accordStats.economyMenu)
                  ? (_openBlock(), _createBlock(_component_som_icon_subtract_alt, {
                      key: 0,
                      display: "block"
                    }))
                  : (_openBlock(), _createBlock(_component_som_icon_add_filled, {
                      key: 1,
                      display: "block"
                    }))
              ])
            ]),
            _createVNode(_component_som_collapse, {
              "aria-expanded": "false",
              ref: "economyMenu",
              collapsed: "true"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_som_list, {
                  class: "mb-2",
                  type: "sidebar"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.economy, (source) => {
                      return (_openBlock(), _createBlock(_component_som_list_item, {
                        key: source.topic,
                        active: source.topic === _ctx.$router.currentRoute.value.name
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: `/economy/${source.topic}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(source.metric), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1032, ["active"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512),
            _createElementVNode("button", {
              type: "button",
              class: "d-flex justify-content-between nav-title",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.toggle(this.$refs.populationMenu)))
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "nav-title__label" }, "Population", -1)),
              _createElementVNode("span", _hoisted_8, [
                (_ctx.accordStats.populationMenu)
                  ? (_openBlock(), _createBlock(_component_som_icon_subtract_alt, {
                      key: 0,
                      display: "block"
                    }))
                  : (_openBlock(), _createBlock(_component_som_icon_add_filled, {
                      key: 1,
                      display: "block"
                    }))
              ])
            ]),
            _createVNode(_component_som_collapse, {
              "aria-expanded": "false",
              ref: "populationMenu",
              collapsed: "true"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_som_list, {
                  class: "mb-2",
                  type: "sidebar"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.population, (source) => {
                      return (_openBlock(), _createBlock(_component_som_list_item, {
                        key: source.topic,
                        active: source.topic === _ctx.$router.currentRoute.value.name
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: `/population/${source.topic}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(source.metric), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1032, ["active"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("main", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_router_view)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_som_footer)
  ], 64))
}